import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    maxHeight: '60vh',
  },
  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  justificationText: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    textAlign: 'justify',
    whiteSpace: 'pre-line',
  },
  metsList: {
    padding: 0,
  },
  metItem: {
    padding: theme.spacing(1, 0),
    alignItems: 'flex-start',
  },
  metIcon: {
    minWidth: 32,
    marginTop: 4,
  },
  checkIcon: {
    color: theme.palette.success.main,
  },
  xIcon: {
    color: theme.palette.error.main,
  },
  metPrimary: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  metSecondary: {
    color: theme.palette.text.secondary,
    marginTop: 4,
  },
  approvedChip: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  rejectedChip: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
}))

export default styles
